export const environment = {
  disableSyncNow: true,
  tokenUrl: 'https://rsiweb-t.rsilink.com/net/mvc/api/auth',
  apiUrl: 'https://pmp-api-test.rsilink.com',
  flowerBaseUrl: 'https://pmp-test.rsilink.com/flower',
  digitalAvailabilityRestaurants: null, 
  modifierCodesFeatureEnabled: true, 
  tierAlignEnabled: true, 
  cancelAvailabilityEnabled: true
};
